import {verifyLeadershipClaimConfig} from 'src/components/MicroScholarships/VerifyLeadershipClaim';
import {clubClaimedConfig} from 'src/components/MicroScholarships/ClubClaimed';

const hsModals = [verifyLeadershipClaimConfig, clubClaimedConfig];

export default hsModals;
